import { useState } from "react";
import api from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { toast } from "sonner";

export default function ChangePasswordDialog({ open, onOpenChange }) {
    const [oldPw, setOldPw] = useState("");
    const [newPw, setNewPw] = useState("");
    const [confirmPw, setConfirmPw] = useState("");
    const [saving, setSaving] = useState(false);

    const reset = () => { setOldPw(""); setNewPw(""); setConfirmPw(""); };

    const submit = async (e) => {
        e.preventDefault();
        if (newPw.length < 6) return toast.error("新密码至少 6 位");
        if (newPw !== confirmPw) return toast.error("两次输入的新密码不一致");
        setSaving(true);
        try {
            await api.post("/auth/change-password", { old_password: oldPw, new_password: newPw });
            toast.success("密码已更新，下次登录请使用新密码");
            reset();
            onOpenChange(false);
        } catch (err) {
            toast.error(err.response?.data?.detail || "修改失败");
        } finally {
            setSaving(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={(o) => { if (!o) reset(); onOpenChange(o); }}>
            <DialogContent className="max-w-md" data-testid="change-password-dialog">
                <DialogHeader>
                    <DialogTitle>修改密码</DialogTitle>
                </DialogHeader>
                <form onSubmit={submit} className="space-y-4 pt-2">
                    <div className="space-y-1.5">
                        <Label>当前密码 *</Label>
                        <Input
                            data-testid="old-password-input"
                            type="password"
                            value={oldPw}
                            onChange={(e) => setOldPw(e.target.value)}
                            required
                            className="font-mono"
                            autoFocus
                        />
                    </div>
                    <div className="space-y-1.5">
                        <Label>新密码 * (至少 6 位)</Label>
                        <Input
                            data-testid="new-password-input"
                            type="password"
                            minLength={6}
                            value={newPw}
                            onChange={(e) => setNewPw(e.target.value)}
                            required
                            className="font-mono"
                        />
                    </div>
                    <div className="space-y-1.5">
                        <Label>确认新密码 *</Label>
                        <Input
                            data-testid="confirm-password-input"
                            type="password"
                            minLength={6}
                            value={confirmPw}
                            onChange={(e) => setConfirmPw(e.target.value)}
                            required
                            className="font-mono"
                        />
                    </div>
                    <DialogFooter className="pt-2">
                        <Button type="button" variant="outline" onClick={() => { reset(); onOpenChange(false); }}>取消</Button>
                        <Button
                            type="submit"
                            data-testid="submit-change-password-btn"
                            disabled={saving}
                            className="bg-gold-600 hover:bg-gold-700 text-white"
                        >
                            {saving ? "保存中..." : "确认修改"}
                        </Button>
                    </DialogFooter>
                </form>
            </DialogContent>
        </Dialog>
    );
}
